import React, { PureComponent } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { get, filter } from "lodash";
import { onlyForCostNumbers, onlyNumbers } from "../../validation";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DatePicker } from "../../component";

export class SecretaryReviewDate extends PureComponent {
  state = {
    projectImplementationSecretaryReviewDate: [{}],
    error: [{}]
  };

  componentDidMount() {
    const { projectImplementationSecretaryReviewDate } = this.props;
    let _projectImplementationSecretaryReviewDate =
      projectImplementationSecretaryReviewDate &&
      projectImplementationSecretaryReviewDate.length
        ? projectImplementationSecretaryReviewDate.map((value, index) => {
            return {
              projectImplementationSecretaryReviewDate: value
            };
          })
        : null;

    if (_projectImplementationSecretaryReviewDate !== null) {
      this.setState({
        projectImplementationSecretaryReviewDate: [
          ..._projectImplementationSecretaryReviewDate
        ]
      });
    }
  }

  onRemoveDates = index => {
    const { updateParentState, updateParentStateError } = this.props;
    this.setState(prevState => {
      prevState.projectImplementationSecretaryReviewDate.splice(index, 1);
      prevState.error.splice(index, 1);
      let _projectImplementationSecretaryReviewDate =
        prevState.projectImplementationSecretaryReviewDate &&
        prevState.projectImplementationSecretaryReviewDate.length &&
        prevState.projectImplementationSecretaryReviewDate.map(item => {
          return item.projectImplementationSecretaryReviewDate;
        });
      updateParentState(
        "projectImplementationSecretaryReviewDate",
        _projectImplementationSecretaryReviewDate
      );
      updateParentStateError("locations", prevState.error);
      return {
        projectImplementationSecretaryReviewDate: [
          ...prevState.projectImplementationSecretaryReviewDate
        ],
        error: [...prevState.error]
      };
    });
  };

  onAddDates = () => {
    const {
      updateParentState,
      updateParentStateError,
      isFormTypeNotDefault
    } = this.props;

    this.setState(
      prevState => {
        return {
          projectImplementationSecretaryReviewDate: [
            {},
            ...prevState.projectImplementationSecretaryReviewDate
          ],
          error: [{}, ...prevState.error]
        };
      },
      () => {
        let _projectImplementationSecretaryReviewDate =
          this.state.projectImplementationSecretaryReviewDate &&
          this.state.projectImplementationSecretaryReviewDate.length &&
          this.state.projectImplementationSecretaryReviewDate.map(item => {
            return item.projectImplementationSecretaryReviewDate;
          });
        updateParentState(
          "projectImplementationSecretaryReviewDate",
          _projectImplementationSecretaryReviewDate
        );
        updateParentStateError(
          "projectImplementationSecretaryReviewDate",
          this.state.error
        );
      }
    );
  };

  onChange = (value, key, index) => {
    const { updateParentState, updateParentStateError } = this.props;

    this.setState(prevState => {
      prevState.projectImplementationSecretaryReviewDate[index] = {
        ...prevState.projectImplementationSecretaryReviewDate[index],
        [key]: value
      };
      let _projectImplementationSecretaryReviewDate =
        prevState.projectImplementationSecretaryReviewDate &&
        prevState.projectImplementationSecretaryReviewDate.length &&
        prevState.projectImplementationSecretaryReviewDate.map(item => {
          return item.projectImplementationSecretaryReviewDate;
        });
      _projectImplementationSecretaryReviewDate = _projectImplementationSecretaryReviewDate.filter(
        item => {
          return item !== null;
        }
      );
      updateParentState(
        "projectImplementationSecretaryReviewDate",
        _projectImplementationSecretaryReviewDate
      );
      updateParentStateError(
        "projectImplementationSecretaryReviewDate",
        prevState.error
      );
      return {
        projectImplementationSecretaryReviewDate: [
          ...prevState.projectImplementationSecretaryReviewDate
        ],
        error: [...prevState.error]
      };
    });
  };

  render() {
    const { isFormTypeNotDefault } = this.props;
    const { projectImplementationSecretaryReviewDate } = this.state;

    const template = projectImplementationSecretaryReviewDate.map(
      (param, index) => {
        return (
          <React.Fragment>
            <div className={`added-location-wrapper added-date-wrapper`}>
              <div className="added-location-detail">
                <div className="location-name d-flex">
                  <Form.Group
                    className={`${
                      isFormTypeNotDefault ? "secretary-field" : ""
                    } field-mscb`}
                  >
                    <DatePicker
                      isClearable={get(
                        param,
                        "projectImplementationSecretaryReviewDate"
                      )}
                      selected={get(
                        param,
                        "projectImplementationSecretaryReviewDate",
                        ""
                      )}
                      value={get(
                        param,
                        "projectImplementationSecretaryReviewDate",
                        ""
                      )}
                      onChange={value => {
                        this.onChange(
                          value,
                          "projectImplementationSecretaryReviewDate",
                          index
                        );
                      }}
                    />
                  </Form.Group>
                  {projectImplementationSecretaryReviewDate &&
                  projectImplementationSecretaryReviewDate.length ? (
                    index === 0 ? (
                      projectImplementationSecretaryReviewDate.length &&
                      projectImplementationSecretaryReviewDate.length < 10 ? (
                        <div
                          className="btn-icon add-more mb-3"
                          title="Add Dates"
                          onClick={this.onAddDates}
                        >
                          +
                        </div>
                      ) : (
                        <div
                          className="btn-icon delete-location mb-3"
                          title="Delete"
                          onClick={() => {
                            this.onRemoveDates(index);
                          }}
                        />
                      )
                    ) : (
                      <div
                        className="btn-icon delete-location mb-3"
                        title="Delete"
                        onClick={() => {
                          this.onRemoveDates(index);
                        }}
                      />
                    )
                  ) : null}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    );

    return (
      <React.Fragment>
        <div className="added-location">{template}</div>
      </React.Fragment>
    );
  }
}

export default SecretaryReviewDate;
